import fetchLatestProcessLog from './fetchLatestProcessLog';

export default async function getNextProcessLogNumber({
  project,
  process,
  pPart = null,
  stepPPartId = null,
}) {
  const processLog = await fetchLatestProcessLog({
    project,
    process,
    pPart,
    stepPPartId,
    orderByField: 'number',
  });

  return (processLog?.number || 0) + 1;
}
